import { render, staticRenderFns } from "./OnlyOfficeEditor.vue?vue&type=template&id=8d4980cc&scoped=true&"
import script from "./OnlyOfficeEditor.vue?vue&type=script&lang=js&"
export * from "./OnlyOfficeEditor.vue?vue&type=script&lang=js&"
import style0 from "./OnlyOfficeEditor.vue?vue&type=style&index=0&id=8d4980cc&prod&scoped=true&lang=css&"
import style1 from "./OnlyOfficeEditor.vue?vue&type=style&index=1&id=8d4980cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4980cc",
  null
  
)

export default component.exports